import { graphql } from "@/graphql/codegen/gql"

graphql(`
  query CommentListQuery($referenceId: String!, $parentTableType: CommentParentTableType!) {
    comment {
      list(input: { referenceId: $referenceId, parentTableType: $parentTableType }) {
        ... on CommentListSuccess {
          comments {
            commentId
            referenceId
            type
            isArchived
            value
            createdBy
            updatedBy
            createdOn
            updatedOn
            archivedOn
            updatedByUser {
              name
            }
            createdByUser {
              name
            }
            archivedByUser {
              name
            }
          }
        }
        ... on CommentListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation UpdateCommentMutation($input: CommentUpdateInput!) {
    comment {
      update(input: $input) {
        ... on CommentUpdateSuccess {
          comment {
            commentId
          }
        }
        ... on CommentUpdateFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
